var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuestions = function SvgQuestions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 110 16A8 8 0 018 0zm.878 10.604H6.963V12.5h1.915v-1.896zM7.963 3.5c-.447 0-.851.076-1.213.228-.362.152-.67.363-.927.634-.256.27-.455.59-.597.96a3.424 3.424 0 00-.213.958L5 6.54h1.793c0-.222.024-.429.073-.622.049-.193.124-.36.225-.504.102-.144.232-.259.39-.345a1.17 1.17 0 01.568-.13c.325 0 .579.09.762.271.183.18.274.46.274.838.008.221-.03.406-.115.554a1.65 1.65 0 01-.336.406 7.335 7.335 0 01-.451.37 3.081 3.081 0 00-.463.436 2.547 2.547 0 00-.385.61c-.087.19-.148.417-.181.681l-.02.205v.554H8.78v-.468c.033-.246.112-.451.238-.615.126-.164.27-.31.433-.437.163-.127.336-.255.519-.382a2.404 2.404 0 00.878-1.114c.101-.255.152-.579.152-.973a2.228 2.228 0 00-.659-1.539 2.805 2.805 0 00-.932-.597c-.387-.16-.868-.24-1.446-.24z",
    fill: "#222",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Questions.39156677.svg";
export { ForwardRef as ReactComponent };